import { SearchOpportunitiesQuery } from '../types';
import { cleanSearchQuery } from '../../../services/phone/cleanPhoneNumber';
import encodeRFC3986URIComponent from '../../../../helpers/encodeRFC3986URIComponent';

const buildQueryPath = ({
    basePath,
    filters = {},
}: {
    basePath: string;
    filters?: Omit<SearchOpportunitiesQuery, 'queryOptions' | 'agentId'>
}) => {
    const {
        searchQuery,
        createdAt,
        owner,
        score,
        pipelineId,
        stageIds,
        amount,
        tags,
        sortBy,
        sortOrder,
        pageSize,
        page,
    } = filters;
    const params = [];
    if (searchQuery) {
        const cleanedQuery = cleanSearchQuery(searchQuery);
        params.push(`query=${encodeRFC3986URIComponent(cleanedQuery)}`);
    }
    if (createdAt) {
        params.push(`createdAt=${encodeURIComponent(createdAt)}`);
    }
    if (owner) {
        params.push(`owner=${encodeURIComponent(owner)}`);
    }
    if (tags) {
        params.push(`tags=${encodeURIComponent(tags)}`);
    }
    if (score) {
        params.push(`scores=${encodeURIComponent(score)}`);
    }
    if (pipelineId) {
        params.push(`pipelineId=${encodeURIComponent(pipelineId)}`);
    }
    if (stageIds) {
        params.push(`stageIds=${encodeURIComponent(stageIds)}`);
    }
    if (amount) {
        params.push(`amount=${encodeURIComponent(amount)}`);
    }
    if (sortBy) {
        params.push(`sortBy=${encodeURIComponent(sortBy)}`);
    }
    if (sortOrder) {
        params.push(`sortOrder=${encodeURIComponent(sortOrder)}`);
    }
    if (pageSize) {
        params.push(`pageSize=${encodeURIComponent(pageSize)}`);
    }
    if (page) {
        params.push(`page=${encodeURIComponent(page)}`);
    }
    return `${basePath}?${params.join('&')}`;
};

export default buildQueryPath;
